<script>
export default {
    name: 'AnswerRatingVerbesserung',
    data() {
        return {
            formData: {
                improvements: null
            }
        }
    },
    methods: {
        onNextStep(event) {
            event.preventDefault();
            this.$emit('nextStep', this.formData);
        },
    },
};
</script>

<template>
<div class="survey-step survey-step--verbesserung">
    <div>
        <h2 class="survey-step__title">Wie können wir unsere Beratung noch verbessern?</h2>

        <div class="survey-step__body">
            <div class="survey__form-col">
                <label class="form-control form-control--simplified">
                    <span class="form-control__label">Verbesserungsvorschläge</span>
                    <textarea class="form-control__input" v-model="formData.improvements" rows="4"></textarea>
                </label>
            </div>
        </div>

    </div>
    <div>
        <button class="survey-step__action read-more" v-on:click="onNextStep($event)">Weiter</button>
    </div>
</div>
</template>

<style lang="scss"></style>
